import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  name?: string;
  email?: string;
  size?: string;
}
const AccountItem = ({ name = "", email, size = "m" }: IProps) => {
  const FirstName = name?.split(" ")[0];
  let LastName = "";
  if (name?.split(" ").length > 1) {
    LastName = name?.split(" ")[1];
  }
  return (
    <Container>
      <AccountIcon size={size}>
        <AccountIconText size={size}>
          {FirstName[0]}
          {LastName && LastName[0]}
        </AccountIconText>
        <SuccessIcon size={size} />
      </AccountIcon>
      <div>
        <Typography
          size={size ? "" : "xl"}
          weight="medium"
          color={Colors.white100}
        >
          {name}
        </Typography>
        <Typography color={Colors.grey500} size={size ? "s" : "lg"}>
          {email}
        </Typography>
      </div>
    </Container>
  );
};

export default AccountItem;

const Container = styled.div`
  width: 100%;
  margin: 1rem 0;
  display: flex;
  align-items: center;
  position: relative;
`;

const AccountIcon = styled.div<{ size?: string }>`
  width: ${(props) => (props.size === "s" ? "3.6rem" : "4.8rem")};
  height: ${(props) => (props.size === "s" ? "3.6rem" : "4.8rem")};
  border-radius: 50%;
  background-color: ${Colors.purple200};
  border: 1px solid ${Colors.grey400};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-right: 1.6rem;
  text-transform: capitalize;
`;

const AccountIconText = styled.p<{ size?: string }>`
  font-size: ${(props) => (props.size === "s" ? "1.35rem" : "1.8rem")};
  font-family: "Inter", system-ui;
`;

const SuccessIcon = styled.div<{ size?: string }>`
  position: absolute;
  background-color: ${Colors.success};
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
  right: -0.1rem;
  bottom: 0.5rem;
`;
